import React, { useState, useRef } from 'react';

import { Button, Select, Modal, Space, Tooltip, message, DatePicker } from 'antd';
import ProTable from '@ant-design/pro-table';
import axios from '../../../utils/AxiosUtil'
import { useHistory } from 'react-router-dom'
import { procCols } from '../../../constants/processingConstants'
import ProcQuery from './procQuery';
import ReviewBill from './procReview.tsx';
import './proc.less'
import { SyncOutlined } from '@ant-design/icons'
import { queryAxios, mask, unmask, axiosPostAndHint } from '../../../components/reqAndHint';
import { sleep } from '../../../utils/TimeUtil'
import 'moment/locale/zh-cn';
// import locale from 'antd/lib/locale/zh_CN';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { useSelector } from 'react-redux'
const { Option } = Select;
// const history = useHistory();
const { RangePicker } = DatePicker;
import date2Str from '../../../utils/date2Str';


// 待处理列表
export default () => {
    const actionRef = useRef();
    let col = [...procCols];
    const [columns, setColumns] = useState(col);
    const [needSearchForm, setNeedSearchForm] = useState(true);//true表示搜索表单尚未动态加载

    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [recordId, setRecordId] = useState();
    const [recordArea, setRecordArea] = useState();
    const [recordVolCnt, setRecordVolCnt] = useState();
    const [recordDate, setRecordDate] = useState();
    const [selectedRowKeysArr, setSelectedRowkeysArr] = useState([]);
    const [selectedRowArr, setSelectedRowArr] = useState([]);
    const langValue = useSelector(state => state.langList.value)
    const [areaList, setAreaList] = useState([])

    // //审核状态筛选组件
    // col.map((c, i) => {
    //     if (i == 7) {
    //         c.renderFormItem = (_, config, form) => {
    //             return <Select defaultValue="" >
    //                 <Option key="all" value="">所有状态</Option>
    //                 <Option key="unreview" value="未审核">未审核</Option>
    //                 <Option key="reviewed" value="已审核">已审核</Option>
    //             </Select>
    //         };
    //     } else if ((i != 1) && (i != 4)) {
    //         c.renderFormItem = () => { return null };
    //     }
    // });
    // col.push(operCol);

    let winHeight;//窗口宽度，用于明细弹窗
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    // 中英文切换
    const getColumns = (col) => {

        let operCol = {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            valueType: 'option',
            render: (text, record, _, action) => {
                let reviewed = record['审核状态'] == '已审核';
                return [

                    reviewed
                        ? (<Button type="primary" ghost
                            key="query"
                            onClick={() => {
                                setModalType('query');
                                setModalVisible(true);
                                // setRecordId(record.recordId);
                                setRecordId(record._id);
                                setRecordArea(record['地区']);
                                setRecordVolCnt(record['志工人数']);
                                setRecordDate(record['录入日期']);
                            }}
                        >
                            {langValue == 0 ? '查看View' : (langValue == 1 ? '查看' : 'View')}
                        </Button>)
                        : (<Button type="primary"
                            key="editable"
                            onClick={() => {
                                setModalType('review');
                                setModalVisible(true);
                                // setRecordId(record.recordId);
                                setRecordId(record._id);
                                setRecordArea(record['地区']);
                                setRecordVolCnt(record['志工人数']);
                                setRecordDate(record['录入日期']);
                            }}
                        >
                            {langValue == 0 ? '审核Review' : (langValue == 1 ? '审核' : 'Review')}
                        </Button>)
                ];
            }
        };
        let newCol = [...col];
        newCol.push(operCol)
        newCol.forEach((item, i) => {
            if (i == 1) {
                item.renderFormItem = () => {
                    return <RangePicker
                        locale={locale}
                        format="YYYY-MM-DD"
                        placeholder={langValue == 0 ? ['开始日期Start Date', '结束日期End Date'] : (langValue == 1 ? ['开始日期', '结束日期'] : ['Start Date', 'End Date'])}
                    />
                };
            }
            if (i == 4) {
                item.renderFormItem = () => {
                    return <Select defaultValue="" style={{ width: 300 }} showSearch>
                        <Option key="allarea" value="">{langValue == 0 ? '所有地区All Regions' : (langValue == 1 ? '所有地区' : 'All Regions')}</Option>
                        {areaList.map((area, i) => {
                            return <Option key={area} value={area}>{area}</Option>
                        })}
                    </Select>
                };
            }
            if (i == 7) {
                item.renderFormItem = (_, config, form) => {
                    return <Select defaultValue="" >
                        <Option key="all" value="">{langValue == 0 ? '所有状态All Status' : (langValue == 1 ? '所有状态' : 'All Status')}</Option>
                        <Option key="unreview" value="未审核">{langValue == 0 ? '未审核Unaudited' : (langValue == 1 ? '未审核' : 'Unaudited')}</Option>
                        <Option key="reviewed" value="已审核">{langValue == 0 ? '已审核Audited' : (langValue == 1 ? '已审核' : 'Audited')}</Option>
                    </Select>
                };
                item.render = (_, item2) => {
                    return langValue == 0 ? <span>{item2.ch_status}<br />{item2.en_status}</span> : (langValue == 1 ? item2.ch_status : item2.en_status)
                }
            } else if ((i != 1) && (i != 4)) {
                item.renderFormItem = () => { return null };
            }
            item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
        })
        return newCol;

    }
    const rowSelection = {
        alwaysShowAlert: true,
        onChange: (selectedRowKeys, selectedRows) => {
            // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRowkeysArr([...selectedRowKeys]);
            setSelectedRowArr([...selectedRows]);
        },

        getCheckboxProps: (record) => ({
            disabled: record['审核状态'] != '已审核', // 改行checkbox不能被勾选
            name: record.name,
        }),
    };

    //下载
    const download = (billRecordId, area) => {
        // console.log('download...  ', billRecordId);
        mask();

        //先生成excel
        axios.post('/fund/billmgt/createExcel', {
            billRecordId: billRecordId

        }).then((data) => {
            // console.log('createExcel data:', data.data);
            Modal.info({
                title: data.data.msg,

                //模态框点击ok之后再进行下载处理
                onOk() {

                    if (data.data ?.recordCount) {
                        let recordCount = data.data ?.recordCount;

                        //大于6w条记录，则需要从后端获取两个excel文件
                        if (recordCount > 60000) {
                            let excelIndex1 = '-1';
                            axios({
                                url: '/fund/billmgt/downloadExcel', //调用的接口，该接口返回文件流
                                method: 'post',
                                params: {
                                    //接口的参数
                                    billRecordId: billRecordId,
                                    //-1
                                    excelIndex: excelIndex1
                                },
                                responseType: 'blob',
                                timeout: 120000,
                            }).then((response) => {
                                // console.log('downloadExcel response:', response);
                                unmask();
                                const url = window.URL.createObjectURL(new Blob([response.data]));
                                const link = document.createElement('a');
                                link.href = url;
                                //B表命名：地区编号+年月日时分秒
                                let areaCode = area.replace(/\W|_/g, '');
                                let fileName = areaCode + ' ' + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss ') + excelIndex1 + '.xlsx';
                                link.setAttribute('download', fileName); //下载后的文件名为fileName
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                // message.destroy();
                                // message.info("请在浏览器下方查看文件，并等待下载完成", 10);

                            }).catch(e => {
                                unmask();
                                console.log(e);
                                Modal.error({ title: '出错了' })
                            });


                            let excelIndex2 = '-2';
                            axios({
                                url: '/fund/billmgt/downloadExcel', //调用的接口，该接口返回文件流
                                method: 'post',
                                params: {
                                    //接口的参数
                                    billRecordId: billRecordId,
                                    //-1
                                    excelIndex: excelIndex2
                                },
                                responseType: 'blob',
                                timeout: 120000,
                            }).then((response) => {
                                // console.log('downloadExcel response:', response);
                                unmask();
                                const url = window.URL.createObjectURL(new Blob([response.data]));
                                const link = document.createElement('a');
                                link.href = url;
                                //B表命名：地区编号+年月日时分秒
                                let areaCode = area.replace(/\W|_/g, '');
                                let fileName = areaCode + ' ' + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss ') + excelIndex2 + '.xlsx';
                                link.setAttribute('download', fileName); //下载后的文件名为fileName
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                message.destroy();
                                message.info("记录较多将拆分为两个excel文件,请在浏览器下方查看，并等待下载完成", 10);
                                document.getElementById(`/view/billmgt/served`) ?.click();//用点击菜单的方式跳转

                            }).catch(e => {
                                unmask();
                                console.log(e);
                                Modal.error({ title: '出错了' })
                            });


                        } else {

                            axios({
                                url: '/fund/billmgt/downloadExcel', //调用的接口，该接口返回文件流
                                method: 'post',
                                params: {
                                    //接口的参数
                                    billRecordId: billRecordId,
                                },
                                responseType: 'blob',
                                timeout: 120000,
                            }).then((response) => {
                                // console.log('downloadExcel response:', response);

                                unmask();
                                const url = window.URL.createObjectURL(new Blob([response.data]));
                                const link = document.createElement('a');
                                link.href = url;
                                //B表命名：地区编号+年月日时分秒
                                let areaCode = area.replace(/\W|_/g, '');
                                let fileName = areaCode + ' ' + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss') + '.xlsx';
                                link.setAttribute('download', fileName); //下载后的文件名为fileName
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                message.destroy();
                                message.info("请在浏览器下方查看文件，并等待下载完成", 10);
                                document.getElementById(`/view/billmgt/served`) ?.click();//用点击菜单的方式跳转

                            }).catch(e => {
                                unmask();
                                console.log(e);
                                Modal.error({ title: '出错了' })
                            });
                        }

                    }

                }
            })

            unmask();

        }).catch((e) => {
            unmask();
            console.log(e);
            Modal.error({ title: '生成excel出错' })
        })


        // mask();
        // axios({
        //     url: '/billmgt/downloadTableB', //调用的接口，该接口返回文件流
        //     method: 'post',
        //     params: {
        //         //接口的参数
        //         billRecordId: billRecordId,
        //     },
        //     responseType: 'blob',
        //     timeout: 120000,
        //     onDownloadProgress: (evt) => {
        //         console.log('evt:', evt);
        //     }
        // }).then((response) => {
        //     unmask();
        //     const url = window.URL.createObjectURL(new Blob([response.data]));
        //     const link = document.createElement('a');
        //     link.href = url;
        //     //B表命名：地区编号+年月日时分秒
        //     console.log('area:', area);
        //     let areaCode = area.replace(/\W|_/g, '');
        //     let fileName = areaCode + ' ' + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss') + '.xlsx';
        //     link.setAttribute('download', fileName); //下载后的文件名为fileName
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //     message.destroy();
        //     message.info("请在浏览器下方查看文件，并等待下载完成", 10);
        //     // history.push(`/view/billmgt/served`);//跳转至已处理列表
        //     document.getElementById(`/view/billmgt/served`)?.click();//用点击菜单的方式跳转
        // }).catch(e => {
        //     unmask();
        //     Modal.error({ title: '下载出错了：', content: e })
        // });

    }


    //生成
    const batchConvert = async () => {
        let areaSet = new Set();
        let recordIds = selectedRowArr.map(r => {
            areaSet.add(r['地区']);
            return r._id;
        });
        if (areaSet.size > 1) {
            Modal.error({
                title: langValue == 0 ? '只能选同一地区的数据Only data from the same region can be selected' : (langValue == 1 ? '只能选同一地区的数据' : 'Only data from the same region can be selected'),
                content: langValue == 0 ? <>现含{areaSet.size}个地区,请重新选择<br />There are currently {areaSet.size} regions included, please choose again</> :
                    (langValue == 1 ? `现含${areaSet.size}个地区,请重新选择` : `There are currently ${areaSet.size} regions included, please choose again`)
            });
            return;
        }

        //将地区传给下载功能
        let area;
        areaSet.forEach(e => { area = e });
        //批量生成xls并 下载 
        let r = await queryAxios('/billmgt/generate', { recordIds, uid: sessionStorage.getItem('uid'), uname: sessionStorage.getItem('uname') });
        // console.log('gen result:', r);
        if (r ?.data) {
            let { billRecordId, msg, en_msg } = r.data;
            Modal.success({
                content: langValue == 0 ? (msg + en_msg) : (langValue == 1 ? msg : en_msg),
                okText: langValue == 0 ? ('确定OK') : (langValue == 1 ? '确定' : 'OK'),
                onOk: () => { }
            });
            document.getElementById(`/view/billmgt/served`) ?.click()
            // Modal.confirm({
            //     title: '已生成文件，下载或查看',
            //     okText: '开始下载',
            //     cancelText: '仅查看列表',
            //     onOk: () => { download(billRecordId, area) },
            //     onCancel: () => {
            //         // history.push(`/view/billmgt/served`);//跳转至已处理列表
            //         document.getElementById(`/view/billmgt/served`).click();//用点击菜单的方式跳转
            //     },
            // });
        }
    }

    //重新查询并渲染待处理列表
    const reloadRecordList = () => {
        // console.log('重新查询并渲染待处理列表')
        actionRef.current.reload();
    }

    return (
        <div className='proc-wrapper' id='proc-billmgt'>
            <ProTable
                sticky
                columns={getColumns(columns)}
                actionRef={actionRef}
                cardBordered
                rowSelection={rowSelection}
                // toolBarRender={false}
                //工具栏选项
                options={{
                    density: true,
                    fullScreen: true,
                    reload: false,
                    setting: false,
                }}
                request={async (
                    // 第一个参数 params 查询表单和 params 参数的结合
                    // 第一个参数中一定会有 pageSize 和  current ，这两个参数是 antd 的规范
                    params: {
                        pageSize: number;
                        current: number;
                    },
                    sort,
                    filter,
                ) => {
                    // 这里需要返回一个 Promise,在返回之前你可以进行数据转化
                    // 如果需要转化参数可以在这里进行修改
                    // console.log('pro table params:', params, ' sort:', sort, ' filter:', filter);
                    const coverParams = (params) => {
                        let p = { ...params, uid: sessionStorage.getItem('uid') };
                        let { nameOrAccount } = { nameOrAccount: params['账号'] };
                        if (nameOrAccount) {
                            p = { ...p, nameOrAccount };
                        }

                        // console.log('coverParams:', p);
                        return p;
                    }

                    const data = await axios.post('/fund/billmgt/list', coverParams(params), {
                        headers: {
                            uid: sessionStorage.getItem('uid'),
                        },
                        timeout: 60000
                    });
                    const { billRecordList } = data.data;
                    const statusObj = {
                        '未审核': 'Unaudited',
                        '已审核': 'Audited',
                    }
                    // console.log("billmgt record list data:", data.data);
                    let dataSrc = [...billRecordList];
                    dataSrc.forEach((d, i) => {
                        // d.key = i + 1;
                        d['序号'] = i + 1;
                        d.key = i + 1;
                        d.ch_status = d['审核状态']
                        d.en_status = statusObj[d.ch_status]
                        // d._id = i + 1;
                    });
                    if (data.data.areaList && data.data.areaList.length) {
                        // console.log(data.data.areaList);
                        setAreaList(data.data.areaList)
                    }
                    // if (needSearchForm) {
                    //     //动态搜索表单，只在首次交互加载
                    //     let col = [...columns.slice()];
                    //     if (dateList && dateList.length) {
                    //         col[1].renderFormItem = () => {
                    //             return <RangePicker
                    //                 locale={locale}
                    //                 format="YYYY-MM-DD"
                    //                 placeholder={['开始日期', '结束日期']}
                    //             />
                    //         };
                    //     }
                    //     if (areaList && areaList.length) {
                    //         col[4].renderFormItem = () => {
                    //             return <Select defaultValue="" style={{ width: 300 }} showSearch>
                    //                 <Option key="allarea" value="">所有地区</Option>
                    //                 {areaList.map((area, i) => {
                    //                     return <Option key={area} value={area}>{area}</Option>
                    //                 })}
                    //             </Select>
                    //         };
                    //     }
                    //     setNeedSearchForm(false);
                    //     setColumns(col);
                    //     await sleep(200);//有时首次动态更新搜索表单不成功，貌似col和data经过了某种计算
                    // }

                    return {
                        data: dataSrc,
                        // success 请返回 true，
                        // 不然 table 会停止解析数据，即使有数据
                        success: true,
                        // 不传会使用 data 的长度，如果是分页一定要传
                        total: dataSrc.length,
                    };
                }}
                editable={{
                    type: 'multiple',
                }}
                columnsState={{
                    persistenceKey: 'pro-table-singe-demos',
                    persistenceType: 'sessionStorage',
                }}
                rowKey="序号"
                search={{
                    labelWidth: 'auto',
                    span: '5',
                    collapseRender: false,//隐藏收起按钮
                    searchText: langValue == 0 ? '查询Query' : (langValue == 1 ? '查询' : 'Query'),
                    resetText: langValue == 0 ? '重置Reset' : (langValue == 1 ? '重置' : 'Reset'),
                }}
                pagination={{
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100, 1000],
                    showQuickJumper: true,
                    showSizeChanger: true,
                }}
                dateFormatter="string"
                headerTitle={langValue == 0 ? "待处理列表 Pending list" : (langValue == 1 ? "待处理列表" : 'Pending list')}
                tableAlertRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => (
                    <Space size={24}>
                        <span>
                            {langValue == 0 ? `已选${selectedRowKeys.length}项 Selected ${selectedRowKeys.length} items` : (langValue == 1 ? `已选${selectedRowKeys.length}项` : `Selected ${selectedRowKeys.length} items`)}

                            {selectedRowKeys.length ? (<a style={{ marginLeft: 8 }} onClick={onCleanSelected}>
                                {langValue == 0 ? '取消选择Unselected' : (langValue == 1 ? '取消选择' : 'Unselected')}
                            </a>) : null}

                        </span>
                    </Space>
                )}
                tableAlertOptionRender={() => {
                    let empty = !selectedRowKeysArr.length;
                    let Btn = <Button type='primary' icon={<SyncOutlined spin={false} />}
                        disabled={empty}
                        onClick={batchConvert}>{langValue == 0 ? '开票Invoicing' : (langValue == 1 ? '开票' : 'Invoicing')}</Button>;
                    return empty ? (
                        <Tooltip title={langValue == 0 ? <>请先勾选已审核记录<br />Please check the approved records first</> : (langValue == 1 ? '请先勾选已审核记录' : 'Please check the approved records first')}>
                            {Btn}
                        </Tooltip>
                    ) : Btn;
                }}
                onRequestError={(error) => {
                    error = typeof error == 'object' ? JSON.stringify(error) : error;
                    Modal.error({
                        title: langValue == 0 ? '表格加载错误Table loading error' : (langValue == 1 ? '表格加载错误' : 'Table loading error'),
                        content: error
                    });
                }}
            />
            <Modal
                centered
                visible={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                width={'100%'}
                footer={false}
                bodyStyle={{ minHeight: winHeight }}
                destroyOnClose={true}//关闭时清空（重新加载子组件）
                maskClosable={false}//点击遮罩不关闭
                closable={false}//不显示右上角的关闭按钮（X)

            >
                {modalType == 'review'
                    ? <ReviewBill recordId={recordId}
                        recordArea={recordArea}
                        recordDate={recordDate}
                        recordVolCnt={recordVolCnt}
                        setModalVisible={setModalVisible}
                        reloadRecordList={reloadRecordList}
                    />
                    : <ProcQuery recordId={recordId}
                        recordArea={recordArea}
                        recordVolCnt={recordVolCnt}
                        recordDate={recordDate}
                        setModalVisible={setModalVisible}
                    />
                }
            </Modal>
        </div>
    );
};     